<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">
            {{ "PurchaseEdit.acquiredSessions" | translate }}
        </h5>
        <div class="card-text">
            @for (week of weeks; track week) {
                <div class="voffset-20">
                    <div class="main-blue">{{ week.title }}</div>
                    @for (item of week.sessions; track item) {
                        <div>
                            <app-purchase-edit-session-summary-item
                                [item]="item"
                            ></app-purchase-edit-session-summary-item>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="card no-border voffset-20">
            <div class="card-body">
                <div class="row">
                    <div
                        class="col-sm-4 offset-sm-6 bolded text-align-right"
                        [translate]="'PurchaseDetails.tuition'"
                    ></div>
                    <div
                        class="col-sm-1 main-green bolded text-align-right old-price"
                    >
                        {{ cartSummary.originalTotalAmount | amount }}
                    </div>
                    <div class="col-sm-1 main-green bolded text-align-right">
                        {{ cartSummary.totalAmount | amount }}
                    </div>
                </div>
                @if (cartSummary.deduction.numberOfDays > 0) {
                    <div class="row">
                        <div
                            class="col-sm-4 offset-sm-6 bolded text-align-right"
                        >
                            <span
                                [translate]="
                                    'PurchaseDetails.creditDaysRedemption'
                                "
                            ></span>
                            <span class="main-red">
                                (
                                <span
                                    >-{{ cartSummary.deduction.numberOfDays }}
                                </span>
                                @if (cartSummary.deduction.numberOfDays == 1) {
                                    <span
                                        [translate]="
                                            'PurchaseDetails.redemptionDays'
                                        "
                                    ></span>
                                }
                                @if (cartSummary.deduction.numberOfDays > 1) {
                                    <span
                                        [translate]="
                                            'PurchaseDetails.redemptionDays'
                                        "
                                    ></span>
                                }
                                ):
                            </span>
                        </div>
                        <div class="col-sm-2 main-red bolded text-align-right">
                            <span
                                >-{{
                                    cartSummary.deduction.value | amount
                                }}</span
                            >
                        </div>
                    </div>
                }

                <div class="row">
                    <div
                        class="col-sm-4 offset-sm-6 bolded text-align-right"
                        [translate]="'PurchaseDetails.additionalOptions'"
                    ></div>
                    <div class="col-sm-2 main-green bolded text-align-right">
                        {{ cartSummary.optionsAmount | amount }}
                    </div>
                </div>

                @if (
                    cartSummary.paymentMethodFeeAmount ||
                    cartSummary.originalPaymentMethodFeeAmount
                ) {
                    <div class="row">
                        <div
                            class="col-sm-4 offset-sm-6 bolded text-align-right"
                        >
                            {{ cartSummary.paymentMethodFeeDescription }}
                        </div>
                        <div
                            class="col-sm-1 main-green bolded text-align-right old-price"
                        >
                            {{
                                cartSummary.originalPaymentMethodFeeAmount
                                    | amount
                            }}
                        </div>
                        <div
                            class="col-sm-1 main-green bolded text-align-right"
                        >
                            {{ cartSummary.paymentMethodFeeAmount | amount }}
                        </div>
                    </div>
                }

                <hr class="offset-sm-8" />
                <div class="row">
                    <div
                        class="col-sm-4 offset-sm-6 bolded text-align-right"
                        [translate]="'PurchaseDetails.toBePaid'"
                    ></div>
                    <div
                        class="col-sm-1 main-green bolded text-align-right old-price"
                    >
                        {{
                            cartSummary.originalTotalIncludingPaymentMethodFeeAmount
                                | amount
                        }}
                    </div>
                    <div class="col-sm-1 main-green bolded text-align-right">
                        {{
                            cartSummary.totalIncludingPaymentMethodFeeAmount
                                | amount
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
